export class UpdateRemoteDatabaseAccessDto {
    constructor(public Id: number, public UserId: number, public RemoteUserName: string) {
    }
}